define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/widget/RadioToggleButton",
	"./util",
	"./_Plugin",
	"dojo/text!./resources/Button.html",
], function(declare,locale,RadioToggleButton,util,_Plugin,template) {

	return declare([RadioToggleButton, _Plugin], {
		bHideWhenDisabled: true,
		bText: true,
		cssStyle: "text-anchor",
		isTextShape: "isTextShape",
		propertyKey: util.shapeProperties.autosize,
		radioClass: "svgAutosize",
		templateString: template,
		
		/**
		 * Update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {Boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			this.set("checked", this.editor.canvasApp.selection.getCommonValue(shapes, this.propertyKey, true) === this.cssValue);
			return this.inherited(arguments);
		},

		/**
		 * @param  {Event} e
		 */
		onClick: function(e) {
			this.editor.canvasApp.pageApi().setShapeAutosizeValues(this.cssValue, true);
		}
	});
});
